import React from 'react';
import { LazyImage } from '../../../../commonv3/components/atoms/images/LazyImage';
import './multiCreatorBanner.module.scss';
import BannerPc from './images/banner-mc-pc.png';
import BannerSp from './images/banner-mc-sp.png';

export const BannerPcImage = () => <BannerImage image={BannerPc} />;

export const BannerSpImage = () => <BannerImage image={BannerSp} />;
export const BannerImage = ({ image }) => (
  <div styleName="image">
    <LazyImage src={image} offset={100} />
  </div>
);

export const BannerDescription = ({ header = '', children }) => (
  <>
    <div styleName="header">{header}</div>
    <div styleName="description">{children}</div>
  </>
);

export const MultiCreatorLpLink = ({ text }) => (
  <a
    id="multicreator_lp_link"
    styleName="lp_button"
    href="https://shelikes.jp/multicreator/?utm_source=21&utm_medium=11&utm_campaign=likesmypage"
    target="_blank"
  >
    <div styleName="button-text">{text}</div>
    <div styleName="arrow" />
  </a>
);

export const MultiCreatorLink = ({ text, href }) => (
  <a id="multicreator_link" styleName="button" href={href} target="_blank">
    <div styleName="button-text">{text}</div>
    <div styleName="arrow" />
  </a>
);
